import { LegalLayout } from "../components/LegalLayout";

export default function Gdpr() {
  return (
    <LegalLayout
      overline="Regolamento UE 2016/679"
      title={<>I tuoi diritti <span className="italic text-[#D47738]">GDPR</span></>}
      updated="Giugno 2026"
      related={[
        { to: "/privacy", label: "Privacy Policy" },
        { to: "/cookie-policy", label: "Cookie Policy" },
      ]}
      sections={[
        {
          h: "Conformità al GDPR",
          p: [
            "Birrificio Vecchio Cinghiale tratta i dati personali nel pieno rispetto del Regolamento Generale sulla Protezione dei Dati (GDPR - Reg. UE 2016/679) e del D.lgs. 196/2003 come modificato dal D.lgs. 101/2018.",
          ],
        },
        {
          h: "Diritti dell'interessato",
          p: ["In qualsiasi momento puoi esercitare gratuitamente i seguenti diritti:"],
          list: [
            "Diritto di accesso: sapere quali dati trattiamo e ottenerne copia.",
            "Diritto di rettifica: correggere dati inesatti o incompleti.",
            "Diritto alla cancellazione ('diritto all'oblio'): chiedere l'eliminazione dei tuoi dati.",
            "Diritto di limitazione: limitare il trattamento in determinati casi.",
            "Diritto alla portabilità: ricevere i tuoi dati in formato strutturato e leggibile.",
            "Diritto di opposizione: opporti al trattamento per motivi legittimi.",
            "Diritto di revoca del consenso: revocare in ogni momento un consenso già prestato.",
          ],
        },
        {
          h: "Come esercitare i diritti",
          p: [
            "Per esercitare i tuoi diritti è sufficiente inviare una richiesta all'indirizzo amministrazione@vecchiocinghiale.beer, indicando il diritto che intendi esercitare. Risponderemo entro 30 giorni dalla ricezione della richiesta.",
          ],
        },
        {
          h: "Reclamo all'autorità di controllo",
          p: [
            "Qualora ritenessi che il trattamento dei tuoi dati avvenga in violazione della normativa, hai il diritto di proporre reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).",
          ],
        },
        {
          h: "Sicurezza dei dati",
          p: [
            "Adottiamo misure tecniche e organizzative adeguate per proteggere i dati da accessi non autorizzati, perdita o divulgazione. I pagamenti sono gestiti tramite Stripe con protocolli di sicurezza certificati PCI-DSS.",
          ],
        },
      ]}
    />
  );
}
